<template>
    <div v-if="loaded">
        <form class="signup_form" @submit.prevent="$emit('next', formData)" v-if="loaded">
          <ul>
              <div class="part">
                  <li>
                      <label>ח.פ</label>
                      <input type="text" v-model="formData.bn_number"  >
                  </li>
                  <li>
                      <label>תעודת התאגדות</label>
                      <!-- <a class="btn_b">
                          <span>העלאת קובץ</span>
                          <span class="upload_icon icon"></span>
                      </a> -->
                      <GalleryInput :max="1" v-model="formData.certificate_Incorporation_file" @onUpload="(data) => { formData.certificate_Incorporation_file = data.id }" />
                      <span class="helper_text">יש להעלות קובץ מסוג PDF המאשר את סוג הסיווג</span>
                  </li>
              </div>
              <div class="part">
                <li>
                    <label>אזורי פעילות בארץ</label>
                   
                    <!-- <multiselect
                        v-model="formData.activity_areas_country"
                        :options="list"
                        :closeOnSelect="false"
                        :multiple="true"
                        :searchable="false"
                        placeholder="בחרו"
                        selectLabel="לחצו לבחירה"
                        deselectLabel="לחצו להסרה"
                        label="name"
                        track-by="id"
                    /> -->
                    <wzMultiSelect v-model="formData.activity_areas_country" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.activity_areas_country" v-if="$store.activity_areas_country.length > 0"/>
                </li>
              </div>
              <div class="part">
                <li>
                    <label>אודות החברה / פרופיל החברה</label>
                    <textarea v-model="formData.about_company" ></textarea>
                </li>
                <li>
                    <label>לוגו החברה</label>
                    <!-- <a class="btn_b">
                        <span>העלאת קובץ</span>
                        <span class="upload_icon icon"></span>
                    </a> -->
                    <GalleryInput v-model="formData.company_logo" :max="1" @onUpload="(data) => { formData.company_logo = data.id }" /> <span>{{ formData.company_logo }}</span>
                    <span class="helper_text">מומלץ להעלות קובץ בגודל מינימלי של 300X200 פיקסלים</span>
                </li>
                <li>
                    <label>מצגת החברה (אופציונאלי)</label>
                    <!-- <a class="btn_b">
                        <span>העלאת קובץ</span>
                        <span class="upload_icon icon"></span>
                    </a> -->
                    <GalleryInput :max="1" v-model="formData.company_presentation" @onUpload="(data) => { formData.company_presentation = data.id }" />
                    <span class="helper_text">מומלץ להעלות קובץ בגודל מינימלי של 300X200 פיקסלים</span>
                </li>
                <li>
                    <label>קישור לסרטון תדמית (אופציונאלי)</label>
                    <input type="text" v-model="formData.promotional_video_link" >
                </li>
              </div>
              <input v-if="state != 'edit'" type="submit" class="btn" value="המשך">
          </ul>
        </form>
    </div>
</template>

<script>
// import Multiselect from 'vue-multiselect'
import WzMultiSelect from '../wzMultiSelect.vue';

import GalleryInput from '../GalleryInput.vue';

export default {
    props: ["updatedData", "state"],
    components: {GalleryInput,WzMultiSelect},
    data() {
        return {
            list:[],
            loaded:false,
            formData: {
                bn_number: '',
                certificate_Incorporation_file: '',
                activity_areas_country: [],
                about_company: '',
                company_logo: '',
                company_presentation: '',
                promotional_video_link: '',
                step: 3
            }
        }
    },
    mounted() {
        console.log(this.updatedData);
        if (this.updatedData) {
            for (const key in this.formData) {
                if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
            }
            this.loaded = true;
        }
    },
    methods: {
        handleUpload(data) {
            if (data && data.id) {
                this.formData.classification_type_file = data.id; 
            }
        },
    },
    watch: {
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    }
}
</script>

<style>

</style>